/*
 * Module handling landlord profile stuff
 */

define([
  "marionette",
  "underscore",
  "messaging/messenger",
  "./landlordProfileView",
  "modules/shared/adminMenu/adminMenuModule",
  "./landlordInfo/landlordInfoModule",
  "./landlordUsers/landlordUsersModule",
  "./landlordProfileModel",
], function (
  Marionette,
  _,
  Messenger,
  LandlordProfileView,
  AdminMenuModule,
  LandlordInfoModule,
  LandlordUsersModule,
  LandlordProfileModel,
) {
  var LandlordProfileController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "landlordProfile";
      this.region = options.region;
      this._setUpVents();
    },
    show: function (landlord) {
      this.landlord = landlord;

      this.layout = new LandlordProfileView.landlordProfileLayout();

      this.sideMenu = this.addSubModule(new AdminMenuModule({ region: this.layout.sideMenu }));
      this.landlordInfo = this.addSubModule(
        new LandlordInfoModule({ region: this.layout.landlordProfile, model: landlord }),
      );
      this.landlordUsers = this.addSubModule(
        new LandlordUsersModule({ region: this.layout.landlordProfile, model: landlord }),
      );

      this.layout.on(
        "show",
        function () {
          this._showSubViews();
        },
        this,
      );

      this.showRegion(this.layout);
    },
    _showSubViews: function () {
      var menuItems = Messenger.reqres.request("landlord:admin:menu:items");
      var menuStyle = Messenger.reqres.request("landlord:admin:menu:style");
      this.sideMenu.show(menuStyle, menuItems, "landlord:profile");
    },
    _setUpVents: function () {
      //Show the landlord admin screen
      Messenger.vent.on(
        "show:account:admin:landlord:profile",
        function (landlord) {
          this.show(landlord);
        },
        this,
      );
    },
  });

  return LandlordProfileController;
});
